"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LTInfoViews = void 0;
var classnames_1 = require("classnames");
var React = require("react");
var styles = require("./index.scss");
var price_1 = require("utils/price");
var common_1 = require("services/page/common");
exports.LTInfoViews = function (props) {
    var columnNum = props.columnNum, name = props.name, price = props.price, originalPrice = props.originalPrice, titleIcons = props.titleIcons, collect = props.collect, interaction = props.interaction;
    if (columnNum === 1) {
        return (React.createElement("div", { className: classnames_1.default(styles["LTInfoViews_" + columnNum]) },
            LTNameViews(name, columnNum),
            LTPriceViews(price, columnNum),
            originalPrice && originalPrice !== price && LTOriginalPriceViews(originalPrice, columnNum),
            React.createElement("div", { className: classnames_1.default(styles["LTBottom_" + columnNum]) },
                LTTitleIconsViews(titleIcons, columnNum),
                LTCollectViews(collect, columnNum))));
    }
    if (columnNum === 2) {
        return (React.createElement("div", { className: classnames_1.default(styles["LTInfoViews_" + columnNum]) },
            LTNameViews(name, columnNum),
            LTPriceViews(price, columnNum),
            React.createElement("div", { className: classnames_1.default(styles["LTBottom_" + columnNum]) },
                originalPrice &&
                    originalPrice !== price &&
                    LTOriginalPriceViews(originalPrice, columnNum),
                interaction === common_1.ModuleInteraction.None && LTCollectViews(collect, columnNum))));
    }
    if (columnNum === 3) {
        return (React.createElement("div", { className: classnames_1.default(styles["LTInfoViews_" + columnNum]) }, LTPriceViews(price, columnNum)));
    }
};
var LTNameViews = function (name, columnNum) {
    return React.createElement("p", { className: classnames_1.default(styles["LTNameViews_" + columnNum]) }, name);
};
var LTPriceViews = function (price, columnNum) {
    return (React.createElement("p", { className: classnames_1.default(styles["LTPriceViews_" + columnNum]), style: {} }, price_1.connectLtPriceForM(String(price), false)));
};
var LTOriginalPriceViews = function (originalPrice, columnNum) {
    return (React.createElement("p", { className: classnames_1.default(styles["LTOriginalPriceViews_" + columnNum]) }, price_1.connectLtPriceForM(String(originalPrice), true)));
};
var LTTitleIconsViews = function (titleIcons, columnNum) {
    return (titleIcons && React.createElement("img", { className: classnames_1.default(styles["LTTitleIconsViews_" + columnNum]), src: titleIcons }));
};
var LTCollectViews = function (collect, columnNum) {
    return (React.createElement("div", { className: classnames_1.default(styles["LTCollectViews_" + columnNum]) },
        React.createElement("img", { src: "https://i.ezbuy.sg/FnMkXCrG8u2d7PImYx0W5gh53i15" }),
        collect && React.createElement("span", null, collect)));
};
